// Copyright © 2021 Move Closer
/**
 * Visual theme of the application.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var AppTheme;
(function (AppTheme) {
    AppTheme["CyberDefence24"] = "cyberdefence24";
    AppTheme["Default"] = "default";
    AppTheme["Energetyka24"] = "emergetyka24";
    AppTheme["InfoSecurity24"] = "infosecurity24";
    AppTheme["PremiumZone"] = "premium_zone";
    AppTheme["KadeciRPZone"] = "kadecirp_zone";
    AppTheme["Space24"] = "space24";
})(AppTheme || (AppTheme = {}));
